import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { SpecialReportModel, SpecialReportSectionsModel } from 'src/Models/SpecialReportModel';
import { CheckAuth } from 'src/Services/utility.service';
import { SpecialReportService } from 'src/Services/special-reports.services';
import { FilterModel } from 'src/Models/filterModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage-special-reports',
  templateUrl: './manage-special-reports.component.html',
  styleUrls: ['./manage-special-reports.component.css']
})
export class ManageSpecialReportsComponent implements OnInit {
  specialReportModel = new SpecialReportModel();
  loginuserID: number = 0;
  productId: number = 1;
  tokenKey: string = '';
  SelectedTool: string;

  specialReportId: number = 0;
  isMultipleClick: boolean = false;
  file: any;
  @ViewChild('fileUpload', { static: true }) fileUpload;
  isShowprogressSpinner = false;
  blockedDocument = false;
  @ViewChild('FreeModelButton', { static: true }) FreeModelButton: ElementRef;
  popupmsg: string = '';
  issubmitted: boolean = false;
  dropdownOptionSettings = {}
  dropdownOptionItems = [];
  listOfOptionSelected = [];
  isSelectExternalURL: boolean = false;
  isSelectFileUpload: boolean = false;
  isErrorOnUploadDoc: boolean = false;
  selectedFiles: File;
  selectedOptionItems = [];
  listOfGetSpecialReportSectionData: SpecialReportSectionsModel[];
  totalRecordCount: number = -1;
  isloading: boolean;
  filterModel = new FilterModel();
  dropdownListSection = [];
  selectedItemsSections = [];
  dropdownSettingsSections = {};
  selectedSectionItems = [];


  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly _fb: FormBuilder,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly specialreportservice: SpecialReportService,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Manage Special Report');
    this.loginuserID = this.sessionStorageService.getAdminUserId();

    this.dropdownOptionSettings = {
      singleSelection: true,
      text: 'Select',
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };
    this.getAllSections();

  }

  // Getter for easy access


  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.FillselectoptionDropdown();
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {

          this.specialReportId = params['id'];
          this.GetSpecialReportData();
        }
      }
      else {
        this.specialReportModel.isActive = true;
      }
    });
    this.dropdownSettingsSections = {
      singleSelection: true,
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No Section available',
    };

  }

  GetSpecialReportData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.specialreportservice.i360SpecialReportFindbySpecialReportId(this.tokenKey, this.specialReportId).subscribe(
      data => {
        if (data != null) {
          this.specialReportModel = data["specialReportData"];

          if (this.specialReportModel.linktype != 0) {
            this.selectedOptionItems = this.dropdownOptionItems.filter(x => x.id == this.specialReportModel.linktype);
            this.listOfOptionSelected.push(this.specialReportModel.linktype);
            if (this.specialReportModel.linktype == 1) {
              document.getElementById('inputfile').style.display = 'none'
              document.getElementById('inputUrl').style.display = 'block'
            }
            else {
              document.getElementById('inputfile').style.display = 'block'
              document.getElementById('inputUrl').style.display = 'none'
            }
          }
          if (this.specialReportModel.sectionId != null && this.specialReportModel.sectionId != 0) {
            if (this.dropdownListSection != null && this.dropdownListSection.length > 0) {
              this.selectedItemsSections = this.dropdownListSection.filter(x => x.id == this.specialReportModel.sectionId);
            }
            else {
              setTimeout(() => {
                this.selectedItemsSections = this.dropdownListSection.filter(x => x.id == this.specialReportModel.sectionId);
              }, 800);
            }
          }
        }
      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  getAllSections() {
    this.specialreportservice.i360SpecialReportSectionListWithIds(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        for (let iCounter = 0; iCounter < data['sectionList'].length; iCounter++) {
          this.dropdownListSection.push(
            { 'id': data['sectionList'][iCounter].sectionId, 'itemName': data['sectionList'][iCounter].sectionName }
          );
        }
      }
    });
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }


  saveSpecialReports(specialreportForm) {
    this.issubmitted = true;

    if (this.listOfOptionSelected.length == 0) {
      //this.showMessage('Please Link Type', 'Link Type Required', 'error');
      return;
    }

    if (this.listOfOptionSelected[0] == 2) {
      if (this.fileUpload.nativeElement.files.length == 0 && !this.specialReportModel.displayDocName) {
        this.showMessage('Please select file', 'File Required', 'error');
        return;
      }
    } else {
      if (specialreportForm.form.invalid) {
        return false;
      }
    }

    event.preventDefault();

    if (this.specialReportModel.title == '' || typeof (this.specialReportModel.title) == 'undefined' || this.specialReportModel.title == null) {
      this.showMessage('Please enter title', 'Title Required', 'error');
      return;
    }

    if (this.specialReportModel.sortOrder == '' || typeof (this.specialReportModel.sortOrder) == 'undefined' || this.specialReportModel.sortOrder == null) {
      // this.showMessage('Please enter SortOrder', 'SortOrder Required', 'error');
      if (this.specialReportModel.sortOrder != 0) {
        return;
      }
    }

    if (this.selectedItemsSections == null || this.selectedItemsSections.length == 0) {
      this.showMessage('Please enter Section', 'Section Required', 'error');
      return;
    }

    this.specialReportModel.createdBy = this.loginuserID;
    this.specialReportModel.modifiedBy = this.loginuserID;
    let formData = new FormData();
    formData.append('specialReportId', this.specialReportModel.specialReportId);
    formData.append('title', this.specialReportModel.title);
    formData.append('displayDocName', this.specialReportModel.displayDocName);
    formData.append('docPath', this.specialReportModel.docPath);
    formData.append('fileUpload', this.fileUpload.nativeElement.files[0]);
    formData.append('createdBy', this.specialReportModel.createdBy);
    formData.append('modifiedBy', this.specialReportModel.modifiedBy);
    formData.append('isActive', this.specialReportModel.isActive);
    formData.append('isAllowallAccess', this.specialReportModel.isAllowallAccess);
    if (this.specialReportModel.externalURL != null && this.specialReportModel.externalURL != 'null') {
      formData.append('externalURL', this.specialReportModel.externalURL);
    }
    formData.append('linktype', this.listOfOptionSelected[0]);
    formData.append('sortOrder', this.specialReportModel.sortOrder);

    formData.append('sectionId', this.selectedItemsSections[0].id);

    if (this.isMultipleClick) {
      return;
    }
    this.isMultipleClick = true;
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.specialreportservice.i360SpecialReportAddUpdate(this.tokenKey, formData).subscribe(
      data => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        this.isMultipleClick = false;
        if (data['specialReportId'] != 0) {
          if (data['specialReportId'] == -1) {
            this.showMessage('Duplicate record found.', 'Duplicate', 'error');
          }
          else {
            if (this.specialReportId == 0)
              this.showMessage('Record saved successfully', 'Save', 'success');
            else
              this.showMessage('Record updated successfully', 'Update', 'success');
            this.specialReportId = 0;
            this.cancelSpecialReports()
          }
        }
      },
      error => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        this.isMultipleClick = false;
        console.log(error)
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  cancelSpecialReports() {
    this.router.navigate(['admin/jsi360/SpecialReports']);
  }

  IfFreeProduct(event) {
    if (this.specialReportId > 0) {
      this.FreeModelButton.nativeElement.click();
      this.popupmsg = event ? 'Are you sure you want to allow access to this item to all companies and subscribers having access to Special Report?' : 'Are you sure you want to remove access to this item from all companies and subscribers having access to this Special Report?';
    }
  }

  Cancelpopup() {
    this.GetSpecialReportData();
  }

  FillselectoptionDropdown() {
    this.dropdownOptionItems.push({ "id": '1', "itemName": "External URL" });
    this.dropdownOptionItems.push({ "id": '2', "itemName": "File Upload" });
  }

  onSelectOption($event) {
    this.listOfOptionSelected = [];
    this.listOfOptionSelected.push($event.id);
    if ($event.id == 1) {
      document.getElementById('inputfile').style.display = 'none'
      document.getElementById('inputUrl').style.display = 'block'
    } else if ($event.id == 2) {
      document.getElementById('inputfile').style.display = 'block'
      document.getElementById('inputUrl').style.display = 'none'
    } else {
      document.getElementById('inputfile').style.display = 'none'
      document.getElementById('inputUrl').style.display = 'none'
    }
  }

  onDeselectOption() {
    document.getElementById('inputfile').style.display = 'none'
    document.getElementById('inputUrl').style.display = 'none'
    this.listOfOptionSelected = [];
  }

  onDeselectAllOption() {
    document.getElementById('inputfile').style.display = 'none'
    document.getElementById('inputUrl').style.display = 'none'
    this.listOfOptionSelected = [];
  }

  fileEvent(event): any {
    var file = event.target.files[0];
    let size = Math.round(file.size / 1024);
    if (size <= 21000) {
      var allowedExtensions = ["doc", "DOC", "docx", "DOCX", "pdf", "PDF"];
      let fileType = file.name.split('.').pop();

      if (!this.isInArray(allowedExtensions, fileType)) {
        this.showMessage('You have selected an invalid file type.System supports following file formats: PDF, DOC, DOCX.', 'Error', 'error');
        this.isErrorOnUploadDoc = true;
        window.scrollTo(0, 0);
      }
      else {
        this.isErrorOnUploadDoc = false;
        this.selectedFiles = event.target.files;
      }
    }
    else {
      this.showMessage('You have selected a larger file. supports file upto 20MB.', 'Error', 'error');
      this.isErrorOnUploadDoc = true;
      window.scrollTo(0, 0);
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  onSelectedSection($event) {
    // this.selectedItemsSections = this.removeElemetninArray(this.selectedItemsSections, $event.id)
    // this.selectedItemsSections.push($event.id);
  }
  onDeSelectedSection($event) {
    if (this.selectedItemsSections != null) {
      if (this.selectedItemsSections.length > 0) {
        this.selectedItemsSections = this.removeElemetninArray(this.selectedItemsSections, $event.id)
      }
    }
  }
}

